/**
 * @mixin
 */
module.exports = {
  props: {
    /** 左边树形选择转化props*/
    treeProps: {
      type: Object,
      default: () => {
        return null;
      },
    },
    /** 左边树形选择转化key*/
    treeNodeKey: {
      type: String,
      default: "id",
    },
    /** 左边树形请求接口*/
    treeUrl: {
      type: String,
      default: "",
    },
    /** 左边树形默认显示文本*/
    treePlaceholder: {
      type: String,
      default: "请输入",
    },
    /** 用于转换树形选择传参*/
    handleTree: {
      type: Function,
      default: null,
    },
  },
};
